import { Card, Group, Progress, Skeleton, Stack, Text } from "@mantine/core";
import { IconUsers } from "@tabler/icons-react";
import type { DashboardData } from "../../../apis/myDashboard";
import { EmptyState } from "../EmptyState";
import { MoneyCell } from "../MoneyCell";
import { SectionHeader } from "../SectionHeader";

interface Props {
  data?: DashboardData;
  loading: boolean;
  currency: string;
}

// ROW 3 — top 5 customers by collected fee in the selected window (UI-SPEC §5.2).
export function TopCustomersCard({ data, loading, currency }: Props) {
  const top = data?.topCustomers ?? [];
  const max = top.reduce((m, c) => Math.max(m, Number(c.amount)), 0) || 1;

  return (
    <Card withBorder radius="md" padding="md" h="100%">
      <Stack gap="sm">
        <SectionHeader title="Шилдэг харилцагч" eyebrow="Шимтгэлээр" />
        {loading ? (
          <Skeleton height={200} radius="sm" />
        ) : top.length === 0 ? (
          <EmptyState icon={<IconUsers size={26} />} message="Энэ хугацаанд гүйлгээ алга." />
        ) : (
          <Stack gap="md">
            {top.map((c) => (
              <Group key={c.rank} gap="sm" wrap="nowrap" align="center">
                <Text size="sm" fw={700} c="dimmed" w={18} ta="center">{c.rank}</Text>
                <Stack gap={4} flex={1} miw={0}>
                  <Group justify="space-between" wrap="nowrap" gap="sm">
                    <Text size="sm" fw={500} truncate>{c.name}</Text>
                    <MoneyCell value={c.amount} currency={currency} size="sm" fw={600} />
                  </Group>
                  <Progress value={(Number(c.amount) / max) * 100} color={c.rank === 1 ? "teal" : "gray.4"} size="sm" radius="xl" />
                </Stack>
              </Group>
            ))}
          </Stack>
        )}
      </Stack>
    </Card>
  );
}
